export default __webpack_public_path__ + "static/media/benefitsIcon3.13512df3.webp";